import { Component } from '@angular/core';

@Component({
  selector: 'app-wordpress-resources',
  templateUrl: './wordpress-resources.component.html',
  styleUrls: ['./wordpress-resources.component.css']
})
export class WordpressResourcesComponent {

}
